import { useMutation } from '@vue/apollo-composable'
import { Customer, MutationCreateNewCustomerArgs } from '../types'
import { gql } from '@apollo/client'

const Mutation = gql`
  mutation CreateNewCustomerMutation(
    $newCustomerDetails: NewCustomerDetailsInput!
    $creditCardDetails: CreditCardDetails!
  ) {
    createNewCustomer(newCustomerDetails: $newCustomerDetails, creditCardDetails: $creditCardDetails) {
      id
    }
  }
`

interface Response {
  createNewCustomer: Customer
}

export const useCreateNewCustomer = () => {
  const { mutate, loading } = useMutation<Response, MutationCreateNewCustomerArgs>(Mutation)

  const createNewCustomer = async (request: MutationCreateNewCustomerArgs) => {
    const result = await mutate(request)
    const customer = result?.data?.createNewCustomer
    if (customer == null) throw new Error('Customer was not returned. Should never happen.')
    return customer
  }

  return { createNewCustomer, loading }
}
